<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/oCLRX1/tc-custom/9780861969487.jpg?1713470185277" alt="This image is the cover for the book Scaled for Success"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Scaled for Success
      </h1>
      <p class="bookDescription body article font2">
        <b>“This wonderful book asks us to consider the mermaid . . . across regions, nations, diasporas, and contemporary socio-cultural configurations.” —Paige West, Claire Tow Professor of Anthropology, Barnard College, Columbia University</b><br/><br/>Emerging from the confluence of Greco-Roman mythology and regional folklore, the mermaid has been an enduring motif in Western culture since the medieval period. It has also been disseminated more widely, initially through Western trade and colonization and, more recently, through the increasing globalization of media products and outlets.<br/><br/><i>Scaled for Success</i> offers the first detailed overview of the mermaid’s dispersal outside Europe. Complementing previous studies of the interrelationship between the mermaid and Mami Wata spirit in West Africa, this volume addresses the mermaid’s presence in a range of Middle Eastern, Asian, Australian, Latin American and North American contexts. Individual chapters identify the manner in which the mermaid has been variously syncretized and/or resignified in contexts as diverse as Indian public statuary, Thai cinema and Coney Islands annual Mermaid Parade.<br/><br/>Rather than lingering as a relic of a bygone age, the mermaid emerges as a versatile, dynamic and, above all, <i>polyvalent</i> figure. Her prominence exemplifies the manner in which contemporary media-lore has extended the currency of established folkloric figures in new and often surprising ways. Analyzing aspects of religious symbolism, visual art, literature and contemporary popular culture, this copiously illustrated volume profiles an intriguing and highly diverse phenomenon.<br/><br/><b>“No matter the reader’s background (literature, folklore, media or cultural studies, and beyond), there is no denying that this work will be a valuable addition to the library of anyone fascinated with mermaids.” —<i>Western Folklore</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Philip Hayward
      </h2>
      
      <p class="authorDescription body article"><P><P>Philip Hayward is editor of the journal <I>Shima</I> and holds adjunct professor positions at the University of Technology Sydney and at Southern Cross University. His previous volume, <I>Making a Splash: Mermaids (and Mermen) in 20th and 21st Century Audiovisual Media</I>, was published by John Libbey Publishing/Indiana University Press in 2017.</P></P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      John Libbey Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6ad9d912